<div class="cf-dlg">
  <div class="cf-dlg-header">
    <div class="cf-dlg-icon">
      <mat-icon>trending_up</mat-icon>
    </div>
    <div class="fe-header-text">
      <h2 class="cf-dlg-title">{{ title }}</h2>
      <p class="cf-dlg-subtitle">{{ subtitle }}</p>
    </div>
    <button mat-icon-button class="cf-dlg-close" (click)="close()" [disabled]="saving" aria-label="Cerrar">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <app-loading-state *ngIf="!ready" [message]="isEdit ? 'Cargando inversión…' : 'Preparando formulario…'"></app-loading-state>
  <app-loading-state *ngIf="ready && saving" [message]="isEdit ? 'Guardando inversión…' : 'Creando inversión…'"></app-loading-state>

  <ng-container *ngIf="ready && !saving && loadError">
    <div class="cf-dlg-body">
      <div class="fe-load-error">
        <mat-icon>error</mat-icon>
        <span>{{ isEdit ? 'No se pudo cargar la inversión financiera.' : 'No se pudieron cargar los datos del formulario.' }}</span>
      </div>
    </div>
    <div class="cf-dlg-footer">
      <button mat-stroked-button class="cf-dlg-btn-secondary" (click)="close()">Cerrar</button>
      <button mat-flat-button class="cf-dlg-btn-primary" (click)="retry()">
        <mat-icon>refresh</mat-icon> Reintentar
      </button>
    </div>
  </ng-container>

  <ng-container *ngIf="ready && !saving && !loadError">
    <div class="cf-dlg-body" [formGroup]="form">
      <div class="fif-layout">
        <div class="fif-main">
          <div class="fe-section">
            <span class="cf-dlg-section__label">Datos de la inversión <app-help key="Inversion7"></app-help></span>

            <div class="cf-field--required" [class.cf-field--invalid]="submitted && errors.account">
              <app-autocomplete [control]="accountControl" [config]="{ label: 'Tipo de inversión', placeholder: 'Buscar cuenta…', options: accounts, autoSelectSingle: true, strict: true }">
              </app-autocomplete>
              <div class="cf-field__error" *ngIf="submitted && errors.account"><mat-icon>error</mat-icon> {{ errors.account }}</div>
              <div class="fif-hint" *ngIf="!accounts.length">No tienes cuentas de inversiones financieras (250, 251, 255, 258, 259, 540, 541, 545, 548, 549) en tu plan contable.</div>
            </div>

            <div class="cf-dlg-row">
              <div class="cf-field--required" [class.cf-field--invalid]="submitted && errors.investmentValue">
                <app-field [control]="investmentValueControl" [config]="{ label: 'Valor de la inversión', type: 'number', required: true, suffix: '€', min: 0, step: 0.01, inputmode: 'decimal' }"></app-field>
                <div class="cf-field__error" *ngIf="submitted && errors.investmentValue"><mat-icon>error</mat-icon> {{ errors.investmentValue }}</div>
              </div>

              <div class="cf-field--required" [class.cf-field--invalid]="submitted && errors.investmentDate">
                <app-date [control]="investmentDateControl" [config]="{ label: 'Fecha de la inversión', required: true }"></app-date>
                <div class="cf-field__error" *ngIf="submitted && errors.investmentDate"><mat-icon>error</mat-icon> {{ errors.investmentDate }}</div>
              </div>
            </div>

            <div class="cf-field--required" [class.cf-field--invalid]="submitted && errors.investmentDescription">
              <app-field [control]="investmentDescriptionControl" [config]="{ label: 'Descripción', required: true, maxLength: descriptionMaxLength }"></app-field>
              <div class="cf-field__error" *ngIf="submitted && errors.investmentDescription"><mat-icon>error</mat-icon> {{ errors.investmentDescription }}</div>
            </div>
          </div>

          <div class="fe-section">
            <span class="cf-dlg-section__label">Participaciones y rendimientos</span>

            <div class="cf-dlg-row">
              <div [class.cf-field--invalid]="submitted && errors.numberOfUnitsOrSharesInvested">
                <div class="fif-field-help">
                  <app-field [control]="numberOfUnitsControl" [config]="{ label: 'Nº de participaciones o acciones', type: 'number', min: 0, step: 0.01, inputmode: 'decimal' }"></app-field>
                  <app-help key="Inversion8"></app-help>
                </div>
                <div class="cf-field__error" *ngIf="submitted && errors.numberOfUnitsOrSharesInvested"><mat-icon>error</mat-icon> {{ errors.numberOfUnitsOrSharesInvested }}</div>
              </div>

              <div [class.cf-field--invalid]="submitted && errors.percentageOfProfitabilityOrInterest">
                <div class="fif-field-help">
                  <app-field [control]="percentageControl" [config]="{ label: 'Rentabilidad / interés', type: 'number', suffix: '%', min: 0, step: 0.01, inputmode: 'decimal' }"></app-field>
                  <app-help key="Inversion9"></app-help>
                </div>
                <div class="cf-field__error" *ngIf="submitted && errors.percentageOfProfitabilityOrInterest"><mat-icon>error</mat-icon> {{ errors.percentageOfProfitabilityOrInterest }}</div>
              </div>
            </div>

            <div class="cf-dlg-row">
              <div [class.cf-field--invalid]="submitted && errors.termInMonths">
                <div class="fif-field-help">
                  <app-field [control]="termInMonthsControl" [config]="{ label: 'Plazo (meses)', type: 'number', min: 0, max: 255, step: 1, inputmode: 'numeric' }"></app-field>
                  <app-help key="Inversion10"></app-help>
                </div>
                <div class="cf-field__error" *ngIf="submitted && errors.termInMonths"><mat-icon>error</mat-icon> {{ errors.termInMonths }}</div>
              </div>

              <div [class.cf-field--invalid]="submitted && errors.netBookValue">
                <div class="fif-field-help">
                  <app-field [control]="netBookValueControl" [config]="{ label: 'Valor neto del último balance', type: 'number', suffix: '€', step: 0.01, inputmode: 'decimal' }"></app-field>
                  <app-help key="Inversion11"></app-help>
                </div>
                <div class="cf-field__error" *ngIf="submitted && errors.netBookValue"><mat-icon>error</mat-icon> {{ errors.netBookValue }}</div>
              </div>
            </div>

            <div class="cf-dlg-row fif-row-center">
              <div>
                <app-date [control]="lastBalanceSheetDateControl" [config]="{ label: 'Fecha del último balance' }"></app-date>
              </div>

              <div class="fif-toggle">
                <app-checkbox [formControl]="generatesReturnsControl" [config]="{ label: 'Genera rendimientos' }"></app-checkbox>
                <app-help key="Inversion12"></app-help>
              </div>
            </div>
          </div>
        </div>

        <aside class="fif-aside">
          <div class="fif-doc-head">
            <span class="cf-dlg-section__label">Documento adjunto</span>
            <div class="fif-doc-actions">
              <input #fileInput class="fif-file-input" type="file" accept=".pdf,.png,.jpg,.jpeg" (change)="onFileSelected($event)">
              <button mat-stroked-button type="button" class="cf-btn" (click)="fileInput.click()" [disabled]="loadingFile">
                <mat-icon>file_upload</mat-icon> Subir
              </button>
              <button mat-stroked-button type="button" class="cf-btn" (click)="pickFromFiles()" [disabled]="loadingFile">
                <mat-icon>folder</mat-icon> Ficheros
              </button>
              <button *ngIf="hasFile" mat-stroked-button type="button" class="cf-btn fif-btn--danger" (click)="removeFile()" [disabled]="loadingFile">
                <mat-icon>delete</mat-icon> Quitar
              </button>
            </div>
          </div>

          <app-loading-state *ngIf="loadingFile" [compact]="true" message="Cargando documento…"></app-loading-state>

          <ng-container *ngIf="!loadingFile">
            <div class="fif-preview" *ngIf="hasFile && (imageUrl || pdfUrl); else noFile">
              <img *ngIf="isImage && imageUrl" [src]="imageUrl" alt="Documento de la inversión">
              <iframe *ngIf="isPdf && pdfUrl" [src]="pdfUrl" title="Documento de la inversión"></iframe>
            </div>
            <ng-template #noFile>
              <div class="fif-empty">
                <mat-icon>attach_file</mat-icon>
                <span *ngIf="!hasFile">Adjunta el contrato, la orden de compra o el certificado (PDF, PNG o JPG).</span>
                <span *ngIf="hasFile">Documento adjunto sin vista previa.</span>
              </div>
            </ng-template>
          </ng-container>
        </aside>
      </div>

      <div class="cf-dlg-mismatch fe-save-error" *ngIf="saveError">
        <mat-icon>error</mat-icon>
        <span>{{ saveError }}</span>
      </div>
    </div>

    <div class="cf-dlg-footer">
      <button mat-stroked-button class="cf-dlg-btn-secondary" (click)="close()">Cancelar</button>
      <button mat-flat-button class="cf-dlg-btn-primary" (click)="save()" [disabled]="loadingFile">
        <mat-icon>save</mat-icon> {{ isEdit ? 'Guardar cambios' : 'Crear inversión' }}
      </button>
    </div>
  </ng-container>
</div>
